import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'

import { MessageWallContext } from '@evertel/message'
import { DisplayRoomMessage, DisplayThreadMessage } from '@evertel/stores'
import { Col, Text, Spinner } from '@evertel/web/ui'
import { RoomLoadingState } from '@evertel/web/room'
import MessageHeaderThread from './MessageHeaderThread'
import { MessageHeaderDivider } from './MessageHeaderDivider'
import { Message } from '../../../Message'
import { DateBlock } from '../DateBlock'
import MessageHeaderRoom from './MessageHeaderRoom'

interface MessageListHeaderProps {
    isLoading: boolean
    message: DisplayRoomMessage | DisplayThreadMessage
}

const MessageListHeader: React.FC<MessageListHeaderProps> = observer(({
    isLoading,
    message
}) => {

    const { modelType, modelData } = useContext(MessageWallContext)
    const isRoom = modelType === 'room'

    if (isLoading) {
        return (
            <div className="h-100 ms-2">
                <RoomLoadingState variant="wall">
                    <Spinner />
                    <Text
                        role="alert"
                        aria-live="polite"
                        size="small"
                    >
                        Decrypting messages...
                    </Text>
                </RoomLoadingState>
            </div>
        )
    }

    if (message) {
        return (
            <div style={{ padding: 1 }} className="mt-2">
                {/* Always display DateBlock in Replies */}
                <DateBlock
                    date={(message.createdDate).toString()}
                />
                <Message
                    message={message}
                    modelType={('roomId' in message) ? 'room' : 'thread'}
                    forceHeader={true}
                    variant="reply"
                    showHoverBar={!message.isRetracted}
                />
                <MessageHeaderDivider />
            </div>
        )
    }

    return (
    //must collapse border or virtuoso "alignToBottom" has issues, must not have margin either
        <div style={{ padding: 1 }}>
            <Col align="center" className="mt-4">
                {isRoom ? <MessageHeaderRoom modelData={modelData} /> : <MessageHeaderThread modelData={modelData} />}
            </Col>
            <MessageHeaderDivider />
        </div>
    )

})

export { MessageListHeader }
